import { render } from "./ProjectSingleGallery.vue?vue&type=template&id=b0ef0b6e"
import script from "./ProjectSingleGallery.vue?vue&type=script&lang=js"
export * from "./ProjectSingleGallery.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__